import selectLocalExercise from './selectLocalExercise';
const selectGroupedItems = (state, id) => {
  const localExercise = selectLocalExercise(state, id);
  if (localExercise === undefined) {
    return undefined;
  }
  return localExercise.groupedItems;
};
export default selectGroupedItems;